import React, { useState } from 'react';
import { LockOutlined } from '@mui/icons-material';
import Button from '../../atoms/Button/Button';
import Input from '../../atoms/Input/Input';
import ConfirmBar from '../../atoms/ConfirmBar/ConfirmBar';
import './PasswordForm.css';

const FIELDS = [
  { label: 'Mot de passe actuel',               name: 'old_password' },
  { label: 'Nouveau mot de passe',              name: 'new_password' },
  { label: 'Confirmer le nouveau mot de passe', name: 'confirm'      },
];

const isWeak = (pwd) =>
  pwd.length < 8 || !/[0-9]/.test(pwd) || !/[^a-zA-Z0-9]/.test(pwd);

const validate = (form) => {
  if (isWeak(form.new_password))
    return 'Mot de passe trop faible (8 caractères min., 1 chiffre et 1 caractère spécial requis).';
  if (form.new_password !== form.confirm)
    return 'Le mot de passe de confirmation ne correspond pas.';
  return null;
};

const PasswordForm = ({ onSave, saving, error }) => {
  const [form,        setForm]        = useState({ old_password: '', new_password: '', confirm: '' });
  const [localError,  setLocalError]  = useState('');
  const [showConfirm, setShowConfirm] = useState(false);

  const handle = (e) => {
    setLocalError('');
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  };

  const isFilled = form.old_password && form.new_password && form.confirm;

  const handleRequest = () => {
    const err = validate(form);
    if (err) { setLocalError(err); return; }
    setShowConfirm(true);
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    onSave(form);
  };

  const displayedError = localError || error;

  return (
    <div className="pwf-wrapper">
      <div className="pwf-fields">
        {FIELDS.map((f) => (
          <div key={f.name} className="pwf-field">
            <label className="pwf-label">{f.label}</label>
            <Input
              type="password"
              name={f.name}
              value={form[f.name]}
              onChangeHandler={handle}
              placeholder={f.label}
              additionalClass={`pwf-input-field${
                (f.name === 'confirm'      && localError?.includes('confirmation')) ||
                (f.name === 'new_password' && localError?.includes('faible'))       ||
                (f.name === 'old_password' && error?.toLowerCase().includes('incorrect'))
                  ? ' pwf-input-field--error' : ''
              }`}
            />
          </div>
        ))}
      </div>

      {displayedError && <p className="pwf-error">{displayedError}</p>}

      <div className="pwf-actions">
        <Button
          variant="primary"
          label={saving ? 'Enregistrement…' : 'Changer le mot de passe'}
          icon={!saving ? <LockOutlined /> : null}
          onClick={handleRequest}
          disabled={saving || !isFilled}
        />
      </div>

      {showConfirm && (
        <ConfirmBar
          message="Confirmer le changement de mot de passe"
          onConfirm={handleConfirm}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
};

export default PasswordForm;